import { MinimalCvInterface } from "../types";

export const resolveCurrentCvId = (
  routeCvId: number | undefined,
  userCvs: Array<MinimalCvInterface>,
  loadedCvId: number | undefined
): number | undefined => {
  const routeCvBelongsToUser = userCvs.some((cv) => cv.id === routeCvId);

  return routeCvBelongsToUser ? routeCvId : loadedCvId;
};
